import { ContentCopy } from '@mui/icons-material'
import { Box, Chip, IconButton, Tooltip, Typography } from '@mui/material'
import ApiClient from '../../backend/ApiClient'
import API_URLS from '../../backend/ApiUrls'
import { IContractSchema } from '../../definitions/ContractSchema'
import { useAppDispatch } from '../../store/Hooks'
import { changeRoute } from '../../store/slices/SessionSlice'
import SmartCard from '../controls/cards/SmartCard'
import { Cell, Column, Row, SmartTable } from '../controls/table'
import useCommand from '../hooks/useCommand'
import PermissionsWrapper from '../permissions/PermissionsWrapper'
import { modals } from '../services/ModalService'
import { snackbar } from '../services/SnackbarService'

export default function ContractSchemasPending() {
    const dispatch = useAppDispatch()

    const { execute: executeClone } = useCommand({
        commandFn: async (item: IContractSchema) => {
            modals.openConfirm({
                title: 'Confirm Schema Cloning',
                startIcon: <ContentCopy />,
                children: <p>Are you sure you want to clone this schema?</p>,
                labels: { confirm: 'Clone', cancel: 'Cancel' },
                colors: { confirm: 'primary', cancel: 'primary' },
                onConfirm: async () => {
                    try {
                        const response = await ApiClient.cloneContractSchema(item.uuid)
                        snackbar.show({ severity: 'success', text: `Schema ${response.name} created successfully!` })
                        handleNavigateToContractSchemaEditor(response.uuid)
                    } catch (error) {
                        console.error('Failed to clone:', error)
                        snackbar.show({ severity: 'error', text: `Unable to clone: ${error}` })
                    }
                }
            })
        }
    })

    const handleNavigateToContractSchemaEditor = (uuid: string) => {
        dispatch(changeRoute({
            route: 'contract-schema-editor',
            params: { uuid }
        }))
    }

    const handleRowClick = (indexRow: number, cells: Cell[], row: Row, item: IContractSchema) => {
        if (item) {
            dispatch(changeRoute({
                route: 'contract-schema-editor',
                params: { uuid: item.uuid }
            }))
        } else {
            console.error('Items not found in the rows.')
        }
    }

    const columns: Column<IContractSchema>[] = [
        { id: 'name', label: 'Name' },
        { id: 'createdAt', label: 'Date created',
            customRenderer: cell => {
                const dateStr = (cell.value as string)?.slice(0, 10)
                return <>{dateStr}</>
            }
        },
        {
            id: 'createdByUserName',
            label: 'Created By',
            customRenderer: cell => {
                if (cell.value) return <Typography>{cell.value}</Typography>
            }
        },
        { id: 'isDefault', label: 'Type',
            customRenderer: cell => {
                if (cell.value) {
                    return <Chip label='Default' />
                }
            }
        },
        {
            id: 'uuid',
            label: 'Actions',
            isPK: true,
            customRenderer: (cell, row, item) => {
                return (
                    <Box>
                        <PermissionsWrapper permission='contract-schema.create'>
                            <IconButton
                                onClick={e => {
                                    e.stopPropagation()
                                    executeClone(item)
                                }}>
                                <Tooltip title='Clone' arrow>
                                    <ContentCopy />
                                </Tooltip>
                            </IconButton>
                        </PermissionsWrapper>
                    </Box>
                )
            }
        }

    ]

    return (
        <SmartCard table={true}>
            <SmartTable<IContractSchema>
                toolbar={{
                    columns: true,
                    search: ['name'],
                    filters: true

                }}
                columns={columns}
                noCollapse
                datasource={{
                    remote: {
                        url: API_URLS.os.getPendingContractSchemas,
                        onSuccess: response => {
                            console.log('RESPONSE: ', response)
                            return { items: response } as any
                        }
                    } }}
                onClickRow={handleRowClick}
            />
        </SmartCard>
    )
}
